import {ObjectHelper} from "../helpers/objectHelper";

export default class VueDraggableDefinition {
  static getOptions(overrides: object = {}) {
    return ObjectHelper.merge({
      animation: 150,
      ghostClass: 'drop-in-zone-sortable-ghost',
    }, overrides);
  }
}